import React, { useEffect } from 'react';
import { Drawer } from 'antd';
import { useChatStore } from '../../stores/chatStore';
import { useAuthStore } from '../../stores/authStore';
import ChatConversationList from './ChatConversationList';
import ChatMessages from './ChatMessages';
import css from './Chat.module.css';

function ChatDrawer({ open, onClose }) {
    const { user, token: storeToken } = useAuthStore();
    const authToken = storeToken || localStorage.getItem('token') || localStorage.getItem('access_token');
    const {
        conversations,
        activeConversation,
        loading,
        connect,
        fetchConversations,
        openConversation,
        closeConversation
    } = useChatStore();

    // Drawer ochilganda socket ulanish va suhbatlarni yuklash
    useEffect(() => {
        if (open && authToken) {
            connect(authToken);
            fetchConversations(authToken);
        }
    }, [open, authToken, connect, fetchConversations]);

    // Drawer yopilganda
    const handleClose = () => {
        closeConversation();
        onClose();
    };

    // Suhbatni tanlash
    const handleSelectConversation = (conv) => {
        openConversation(conv, authToken);
    };

    // Xabarlardan orqaga qaytish
    const handleBack = () => {
        closeConversation();
    };

    const userId = user?.id;

    return (
        <Drawer
            title={activeConversation ? null : 'Xabarlar'}
            placement="right"
            onClose={handleClose}
            open={open}
            size="default"
            styles={{
                body: { padding: 0, height: '100%', display: 'flex', flexDirection: 'column' },
                header: activeConversation ? { display: 'none' } : {}
            }}
        >
            <div className={css.chatContainer}>
                {activeConversation ? (
                    <ChatMessages
                        conversation={activeConversation}
                        userId={userId}
                        onBack={handleBack}
                    />
                ) : (
                    <ChatConversationList
                        conversations={conversations}
                        loading={loading}
                        onSelect={handleSelectConversation}
                        activeId={activeConversation?.id}
                    />
                )}
            </div>
        </Drawer>
    );
}

export default ChatDrawer;
